import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import ListAdvancedSpecializations from "./List";
import ShowAdvancedSpecializations from "./Show/Show";
import CreateAdvancedSpecializations from "./Create";
import EditAdvancedSpecializations from "./Edit";
import { ADVANCED_SPECIALIZATIONS, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <WorkspacePremiumIcon />,
  name: SpecialistServicePath + ADVANCED_SPECIALIZATIONS,
  title: "ВСД",
  recordRepresentation: "nameBg",
  list: <ListAdvancedSpecializations />,
  show: <ShowAdvancedSpecializations />,
  create: <CreateAdvancedSpecializations />,
  edit: <EditAdvancedSpecializations />,
  permission: permissions.canPreviewAdvancedSpecializations,
  showPermission: permissions.canPreviewAdvancedSpecializations,
  createPermission: permissions.canCreateAdvancedSpecializations,
  editPermission: permissions.canUpdateAdvancedSpecializationsInfo,
};
